import { myDashboardApi } from "@/features/my-dashboard/api";
import { useMutation } from "@tanstack/react-query";

const useUploadUnoFile = () => {
  return useMutation({
    mutationFn: (file: File) => myDashboardApi.uploadUnoFile(file),
  });
};

export default useUploadUnoFile;
